import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const SITE = "Il Cassetto delle Giraffe di Fabio Campana";

export default function Terms() {
  return (
    <div className="relative z-10">
      <Header />
      <article className="max-w-3xl mx-auto px-6 md:px-8 pt-16 md:pt-24 pb-10" data-testid="terms-page">
        <p className="label-ui text-[#9F583F] mb-5">Note legali</p>
        <h1 className="font-display text-5xl md:text-6xl leading-[1] tracking-tight text-[#1C1917]">
          Termini e Condizioni
        </h1>
        <div className="article-body mt-10 font-body text-lg leading-loose text-[#292524] space-y-5">
          <p>
            Benvenuto su <strong>{SITE}</strong>. L'accesso e l'utilizzo di questo sito implicano
            l'accettazione dei presenti Termini e Condizioni. Ti invitiamo a leggerli con attenzione.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">1. Contenuti del blog</h2>
          <p>
            Gli articoli, i testi e le immagini pubblicati rappresentano opinioni personali dell'autore
            e hanno finalità informativa e di intrattenimento. L'autore si impegna a fornire contenuti
            accurati ma non garantisce la completezza o l'attualità delle informazioni.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">2. Proprietà intellettuale</h2>
          <p>
            Tutti i contenuti originali (testi, immagini, grafica) sono di proprietà dell'autore e sono
            protetti dalle leggi sul diritto d'autore. È vietata la riproduzione, anche parziale, senza
            autorizzazione scritta, salvo la condivisione tramite gli appositi pulsanti social.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">3. Commenti degli utenti</h2>
          <p>
            Gli utenti possono commentare gli articoli fornendo nome, cognome ed email. L'autore si
            riserva il diritto di moderare, modificare o rimuovere commenti ritenuti offensivi, diffamatori,
            spam o non pertinenti, senza obbligo di preavviso.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">4. Spazi pubblicitari</h2>
          <p>
            Gli spazi dedicati alle aziende ("Sponsor") contengono link a siti di terze parti. L'autore
            non è responsabile dei contenuti, dei prodotti o dei servizi offerti da tali siti esterni.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">5. Limitazione di responsabilità</h2>
          <p>
            L'autore non potrà essere ritenuto responsabile per eventuali danni derivanti dall'uso o
            dall'impossibilità di utilizzare il sito e i suoi contenuti.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">6. Modifiche</h2>
          <p>
            I presenti Termini possono essere aggiornati in qualsiasi momento. Le modifiche entrano in
            vigore dal momento della pubblicazione su questa pagina.
          </p>

          <p className="text-[#57534E] italic pt-6">
            Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { month: "long", year: "numeric" })}.
            Per qualsiasi domanda puoi contattarci tramite la pagina Contatti.
          </p>
        </div>
      </article>
      <Footer />
    </div>
  );
}
